export enum AdvisorsListRoutePathsEnum {
  ADVISORS_LIST = '/planners',
}
